const list = [
    // { url: '/blog', name: 'Blogs', type: 'blog', library: '' },
    // {url:'/videos/blog',name:'Blog Video',type:'blog',library:'video'},
    // {url:'/audio',name:'Audios',type:'',library:'audio'},

    // {url:'/audio/blog',name:'Blog Audio',type:'blog',library:'audio'},
    // {url:'/audio/ebook',name:'Ebooks Audio',type:'ebook',library:'audio'},
    // {url:'/videos/ebook-playlist',name:'Ebooks',type:'ebook-playlist',library:'video'},
    { url: '/videos/newsletter', name: 'Newsletter Video', type: 'newsletter', library: 'video' },
    // {url:'/audio/newsletter',name:'Newsletter Audio',type:'newsletter',library:'audio'},
    { url: '/newsletter', name: 'Newsletter', type: 'newsletter', library: '' },
    // {url:'/subscribers',name:'Subscribers',type:'meditations',library:''},
    { url: '/videos/live', name: 'Live Q&A', type: 'live', library: 'video' },
    { url: '/videos/unboxingShorts', name: 'Live Unboxing Shorts', type: 'unboxingShorts', library: 'video' },
    { url: '/videos/videos', name: 'Videos', type: 'videos', library: 'video' },
    { url: '/videos/shorts', name: 'Shorts', type: 'shorts', library: 'video' },
    // {url:'/audio/podcast',name:'Podcast',type:'podcast',library:'audio'},
    { url: '/videos/podcast', name: 'Podcast Videos', type: 'podcast', library: 'video' },
    { url: '/videos/music', name: 'Music Videos', type: 'music', library: 'video' },
    { url: '/videos/meditations', name: 'Meditations', type: 'meditations', library: 'video' },
].map(itm => ({ ...itm, id: itm.name.toLowerCase().replaceAll(' ', '_') }))

const name = (library, type) => {
    let ext = list.find(itm => itm.library == library && itm.type == type)
    return ext?.name || type || library || ''
}

const nameByType = (type) => {
    let ext = list.find(itm => itm.type == type && itm.library)
    return ext?.name || type || ''
}

const find = (id) => {
    let ext = list.find(itm => itm.id == id)
    return ext
}

const contentLibrary = {
    list: list.filter(itm => !itm?.hide),
    name,
    find,
    nameByType
};

export default contentLibrary;
